import {
  Button,
  ButtonGroup,
  Hero,
  Page,
  getInternalLinkElement,
  useAccessTokenManagement
} from '@hbo/ui-servicing-react-components';
import { useEffect } from 'react';
import { useDataLayer } from 'react-common-gdlv2';
import { Helmet } from 'react-helmet-async';
import { Trans, useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { RoutePath } from 'types/global';

const PageNotFound: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  // const { track } = useDataLayer();

  // useEffect(() => {
  //   track(`PAGE NOT FOUND: for path ${location.pathname}`, null, t('pageNotFound.title'));
  // }, [location.pathname, t, track]);

  return (
    <>
      <Helmet>
        <title>{t('pageNotFound.title')}</title>
      </Helmet>
      <Hero>
        <Hero.PrimaryContent title={<Trans i18nKey="pageNotFound.title" />} />
      </Hero>
      <Page>
        <Page.Content>
          <p>{t('pageNotFound.line1')}</p>
            <ButtonGroup>
              <Button
                variant="secondary"
                href={RoutePath.FourQuestionVerification}
                onClick={(event: React.MouseEvent<Element, MouseEvent>) => {
                  const pageName = t('pageNotFound.title');
                  // track(
                  //   `CLICK: ${pageName} - ${t('generic.backToLandingPage')} - Button`,
                  //   getInternalLinkElement(event),
                  //   pageName
                  // );
                }}
              >
                <Trans i18nKey="generic.backToLandingPage" />
              </Button>
            </ButtonGroup>
        </Page.Content>
      </Page>
    </>
  );
};

export default PageNotFound;
